import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Link from '@cred/react-link/analytics/Link'
import { Disclosure } from '@cred/react-disclosures-sdk'

import Tooltip from 'components/tooltip'
import { DEFAULT_ADVERTISER_DISCLOSURE } from 'common/constants'

import { PRIVACY_LINK, TERMS_LINK } from './const'
import styles from './styles.module.scss'

// eslint-disable-next-line react/prop-types
export const Divider = ({ className }) => (
  <span className={cx('ml-4 mr-4 secondary500 disclaimer', className)}>|</span>
)

const FooterLinks = ({
  containerClassName,
  linkClassName: linkClassNameProp,
  dividerClassName,
  showTerms = true,
  showPrivacy = true,
  showAdvertiserDisclosure = true,
  small = false,
  children,
  tooltipContentClassName = '',
  tooltipContainerClassName = '',
  tooltipPlacement = 'top',
}) => {
  const linkClassName = cx(small ? styles.small : 'disclaimer', linkClassNameProp)

  return (
    <div className={containerClassName}>
      {showTerms && (
        <Link rel="nofollow" blank href={TERMS_LINK} className={linkClassName}>
          Terms
        </Link>
      )}
      {showPrivacy && (
        <>
          {showTerms && <Divider className={dividerClassName} />}
          <Link rel="nofollow" blank href={PRIVACY_LINK} className={linkClassName}>
            Privacy Policy
          </Link>
        </>
      )}
      {showAdvertiserDisclosure && (
        <>
          <Divider className={dividerClassName} />
          <Tooltip
            analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
            contentClassName={cx('disclaimer neutral500', tooltipContentClassName)}
            triggerClassName={cx('secondary500', linkClassName)}
            containerClassName={tooltipContainerClassName}
            placement={tooltipPlacement}
            triggerContent="Advertiser Disclosure"
          >
            <Disclosure required={false} slug={DEFAULT_ADVERTISER_DISCLOSURE} />
          </Tooltip>
        </>
      )}
      {children}
    </div>
  )
}

FooterLinks.propTypes = {
  containerClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  dividerClassName: PropTypes.string,
  showTerms: PropTypes.bool,
  showPrivacy: PropTypes.bool,
  showAdvertiserDisclosure: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.node,
  tooltipContentClassName: PropTypes.string,
  tooltipContainerClassName: PropTypes.string,
  tooltipPlacement: PropTypes.string,
}

export default FooterLinks
